/*
 * @Description: 新增、编辑机构对话框中各面板共用的数据
 * @Author: wanqian
 * @Date: 2021-06-07 18:28:58
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
    mode: '',
    baseInfoDO: {},
    openingHsvcList: {},
    logoFile: null,
    picFile: null,
    brandingFiles: [],
    srcProvinceList: [],
    srcCityList: [],
    srcCountyList: [],
}

const mutations = {
    changeMode(stateN, mode) {
        stateN.mode = mode;
    },

    changeBaseInfoDO(stateN, baseInfoDO) {
        stateN.baseInfoDO = baseInfoDO;
    },

    changeOpeningHsvcList(stateN, openingHsvcList) {
        stateN.openingHsvcList = openingHsvcList;
    },

    changeLogoFile(stateN, logoFile) {
        stateN.logoFile = logoFile;
    },

    changePicFile(stateN, picFile) {
        stateN.picFile = picFile;
    },

    changeBrandingFiles(stateN, brandingFiles) {
        stateN.brandingFiles = brandingFiles;
    },

    changeSrcProvinceList(stateN, srcProvinceList) {
        stateN.srcProvinceList = srcProvinceList;
    },

    changeSrcCityList(stateN, srcCityList) {
        stateN.srcCityList = srcCityList;
    },

    changeSrcCountyList(stateN, srcCountyList) {
        stateN.srcCountyList = srcCountyList;
    },
}

export default new Vuex.Store({
    state: state,
    mutations: mutations
})


// WEBPACK FOOTER //
// ./src/components/instmng/components/institutiondetails/InstStore.js